import { setProduct, setProducts } from "reduxStore/state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to get Authorization header
const authHeader = (getState) => ({
  Authorization: `Bearer ${getState().token}`,
  "Content-Type": "application/json",
});

// Fetch a single product by ID
export const fetchProduct = (id) => async (dispatch, getState) => {
  try {
    const productResponse = await fetch(`${BASE_URL}/products/${id}`, {
      method: "GET",
      headers: authHeader(getState),
    });

    if (!productResponse.ok) throw new Error("Failed to fetch product");

    const product = await productResponse.json();
    dispatch(setProduct(product));

    return product;
  } catch (error) {
    console.error("Error while fetching product:", error);
    return { error: error.message };
  }
};

// Fetch all products with optional filters
export const fetchProducts =
  ({ page = 1, limit = 10, sort, search, organisation } = {}) =>
  async (dispatch, getState) => {
    try {
      const filters = { page, limit, sort, search, organisation };
      const query = new URLSearchParams(filters).toString();

      const productsResponse = await fetch(`${BASE_URL}/products?${query}`, {
        method: "GET",
        headers: authHeader(getState),
      });

      if (!productsResponse.ok) throw new Error("Failed to fetch products");

      const { data, total } = await productsResponse.json();
      dispatch(setProducts({ data: data, total: total }));

      return data;
    } catch (error) {
      console.error("Error while fetching products:", error);
      return { error: error.message };
    }
  };

// Create a new product
export const createProduct =
  ({ values, organisation }) =>
  async (dispatch, getState) => {
    try {
      const productResponse = await fetch(`${BASE_URL}/products`, {
        method: "POST",
        headers: authHeader(getState),
        body: JSON.stringify(values),
      });

      if (!productResponse.ok) throw new Error("Failed to create product");

      const product = await productResponse.json();
      dispatch(setProduct(product));
      dispatch(fetchProducts({ organisation }));

      return product;
    } catch (error) {
      console.error("Error while creating product:", error);
      return { error: error.message };
    }
  };

// Update an existing product by ID
export const updateProduct =
  ({ productId, values, organisation }) =>
  async (dispatch, getState) => {
    try {
      const productResponse = await fetch(`${BASE_URL}/products/${productId}`, {
        method: "PATCH",
        headers: authHeader(getState),
        body: JSON.stringify(values),
      });
      if (!productResponse.ok) throw new Error("Failed to update product");

      const product = await productResponse.json();
      dispatch(setProduct(product));
      dispatch(fetchProducts({ page: 1, limit: 10, organisation }));

      return product;
    } catch (error) {
      console.error("Error while updating product:", error);
      return { error: error.message };
    }
  };

// Delete an existing product by ID
export const deleteProduct =
  ({ productId, organisation }) =>
  async (dispatch, getState) => {
    try {
      const response = await fetch(`${BASE_URL}/products/${productId}`, {
        method: "DELETE",
        headers: authHeader(getState),
      });

      if (!response.ok) throw new Error("Failed to delete product");

      dispatch(fetchProducts({ page: 1, limit: 10, organisation }));

      return true;
    } catch (error) {
      console.error("Error while deleting product:", error);
      return { error: error.message };
    }
  };
